// extracted by mini-css-extract-plugin
export var container = "_de-0";
export var icon = "_de-1";
export var text = "_de-2";